import { render, staticRenderFns } from "./BaseProfilePhoto.vue?vue&type=template&id=63ab5d7e&scoped=true&"
import script from "./BaseProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./BaseProfilePhoto.vue?vue&type=script&lang=js&"
import style0 from "./BaseProfilePhoto.vue?vue&type=style&index=0&id=63ab5d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab5d7e",
  null
  
)

export default component.exports